
const clientCustomerFullcont        = require('./clientCustomer-fullcont')

export function start(detail){  //console.log('company-dt 5>', detail)
         
      obj[detail.elem].start(detail)

}/**/


const obj = {
      fullcont:           { start: (detail)=>{  clientCustomerFullcont. start(detail)        }},
}







